document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-excerpted-list-button]").forEach((el) => {
    const listTargetSelector = el.getAttribute('data-list-target');
    const listTargetActiveClass = el.getAttribute('data-list-target-active-class');
    const listItemTargetSelector = el.getAttribute('data-list-item-target');
    const buttonContained = el.getAttribute('data-button-contained') !== null;

    let parent = el.parentElement;
    if (buttonContained) {
      parent = parent.parentElement;
    }

    el.addEventListener("click", (e) => {
      e.preventDefault();
      [].forEach.call(parent.querySelectorAll(listItemTargetSelector), (itemEl) => {
        itemEl.classList.remove('layout/none');
      });

      parent.querySelector(listTargetSelector).classList.remove('layout/none');
      parent.querySelector(listTargetSelector).classList.add(listTargetActiveClass);

      if (buttonContained) {
        el.parentElement.remove();
      } else {
        el.remove();
      }

      parent.querySelector(`${listItemTargetSelector} a`).focus();
      window.MoMA.Sol.balanceText.balance(parent.querySelectorAll(`${listItemTargetSelector} .balance-text`));
    });
  });
});
